// Generated by Melange

import * as Buhta_cabinet__Kassa from "../../../../grpc/Kassa.js";
import * as Buhta_cabinet__OrgDashboardHeaderMobile from "../../../molecules/OrgDashboardHeader/OrgDashboardHeaderMobile.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_core__GrpcState from "../../../../../../../packages/core/lib/GrpcState.js";
import * as Curry from "melange.js/curry.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(kkm) {
  return function (idOpt) {
    const id = idOpt !== undefined ? idOpt : "";
    return function (closeShiftButton) {
      return function (openMenu) {
        const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
        let shiftId;
        if (typeof currentRoute === "number") {
          shiftId = id;
        } else {
          switch (currentRoute.TAG | 0) {
            case /* Org */6 :
                const match = currentRoute._1;
                if (typeof match === "number" || match.TAG !== /* Kassa */2) {
                  shiftId = id;
                } else {
                  const match$1 = match._0._0;
                  if (typeof match$1 === "number") {
                    shiftId = id;
                  } else {
                    const match$2 = match$1._1;
                    if (typeof match$2 === "number" || match$2.TAG !== /* Journal */2) {
                      shiftId = id;
                    } else {
                      const match$3 = match$2._0;
                      if (typeof match$3 === "number") {
                        shiftId = id;
                      } else {
                        const shiftid = match$3._0;
                        shiftId = typeof shiftid === "number" || shiftid.TAG !== /* View */0 ? id : shiftid._0;
                      }
                    }
                  }
                }
                break;
            case /* Admin */7 :
                const match$4 = currentRoute._0;
                if (typeof match$4 === "number" || match$4.TAG !== /* Orgs */1) {
                  shiftId = id;
                } else {
                  const match$5 = match$4._0;
                  if (typeof match$5 === "number") {
                    shiftId = id;
                  } else {
                    const match$6 = match$5._1;
                    if (typeof match$6 === "number" || match$6.TAG !== /* Kassa */2) {
                      shiftId = id;
                    } else {
                      const match$7 = match$6._0._0;
                      if (typeof match$7 === "number") {
                        shiftId = id;
                      } else {
                        const match$8 = match$7._1;
                        if (typeof match$8 === "number" || match$8.TAG !== /* Journal */2) {
                          shiftId = id;
                        } else {
                          const match$9 = match$8._0;
                          if (typeof match$9 === "number") {
                            shiftId = id;
                          } else {
                            const shiftid$1 = match$9._0;
                            shiftId = typeof shiftid$1 === "number" || shiftid$1.TAG !== /* View */0 ? id : shiftid$1._0;
                          }
                        }
                      }
                    }
                  }
                }
                break;
            default:
              shiftId = id;
          }
        }
        const func = Buhta_cabinet__Kassa.ZxReportService.view;
        const match$10 = Buhta_core__GrpcState.useModel((function (param) {
                return Curry._4(func, param, kkm, /* [] */0, shiftId);
              }), undefined);
        const dispatch = match$10[1];
        const shiftData = match$10[0];
        React.useEffect((function () {
                Curry._2(dispatch, undefined, undefined);
              }), [
              kkm,
              shiftId
            ]);
        const shiftTitle = typeof shiftData === "string" || shiftData.NAME !== "Data" ? "Отчет" : "Отчет №" + String(shiftData.VAL.serial_id);
        return JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeaderMobile.make, {
                    title: shiftTitle,
                    leftChildren: closeShiftButton,
                    openMenu: openMenu,
                    showMenu: false
                  });
      };
    };
  };
}

function ShiftHeader(Props) {
  return Curry._2(make(Props.kkm)(Props.id), Props.closeShiftButton, Props.openMenu);
}

const make$1 = ShiftHeader;

export {
  make$1 as make,
}
/* Buhta_cabinet__Kassa Not a pure module */
